import React from "react";
import { Question } from "../../../../Entities/Question";
import { Radio, Typography } from "antd";

interface JobApplicationinterviewRoundsMCQOptionsProps {
  question: Question;
  isRoundCompleted: boolean;
}

const JobApplicationinterviewRoundsMCQOptions: React.FC<
  JobApplicationinterviewRoundsMCQOptionsProps
> = ({ question, isRoundCompleted }) => {
  const hasOptions =
    Array.isArray(question.options) && question.options?.length > 0;

  if (!hasOptions) {
    return null;
  }

  const correctAnswer = isRoundCompleted
    ? question.options?.find((option) => option.isCorrectAnswer)?.description
    : null;

  const candidateAnswer = isRoundCompleted
    ? question.responses?.[0]?.description || null
    : null;

  const getOptionClassName = (optionDescription: string): string => {
    if (!isRoundCompleted) {
      return "";
    }

    const isCorrect = optionDescription === correctAnswer;
    const isCandidateAnswer = optionDescription === candidateAnswer;

    if (isCorrect && isCandidateAnswer) {
      // Candidate selected the correct answer
      return "mcq-option-correct-selected";
    } else if (isCorrect) {
      // Correct answer but not selected by candidate
      return "mcq-option-correct";
    } else if (isCandidateAnswer) {
      // Candidate selected wrong answer
      return "mcq-option-wrong";
    }

    return "";
  };

  return (
    <div className="job-application-interview-rounds-mcq-options-container">
      <Typography.Text type="secondary" strong style={{ fontSize: 13 }}>
        Options
      </Typography.Text>

      <div>
        <Radio.Group
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
          size="small"
          value={
            isRoundCompleted && candidateAnswer
              ? candidateAnswer
              : null
          }
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onFocus={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onBlur={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onMouseEnter={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {question.options?.map((option) => {
            const optionClass = getOptionClassName(option.description);
            return (
              <div key={option.description} className={`mcq-option-wrapper ${optionClass}`}>
                <Radio value={option.description}>
                  <span className={optionClass}>{option.description}</span>
                </Radio>
              </div>
            );
          })}
        </Radio.Group>
      </div>
    </div>
  );
};

export default JobApplicationinterviewRoundsMCQOptions;
